import {FullDate as ApiFullDate} from 'gabi-api-ts/v2/common/date/date';

import {
    addSeconds,
    formatApiDateUniversal,
    formatApiTimeShortUniversal,
} from '@/util/apidate-util';

type ChartAxisSecondsSinceProps = {
    since: ApiFullDate;
    x?: number;
    y?: number;
    textAnchor?: string;
    payload?: {
        coordinate: number;
        isShow: boolean;
        offset: number;
        tickCoord: number;
        value: number;
    };
};

function ChartAxisSecondsSince({x, y, since, payload, textAnchor}: ChartAxisSecondsSinceProps) {
    const d = addSeconds(since, payload!.value);
    const isMidnight = d.time.hour === 0;
    const showDate = isMidnight || (x??0) < 100;
    return (
        <g transform={`translate(${x},${y})`}>
            {showDate && (
                <text x={0} y={0} dy={29} textAnchor={textAnchor || 'end'} fill="#fff" fontSize={12}>
                    {formatApiDateUniversal(d.date)}
                </text>
            )}
            <text x={0} y={0} dy={15} textAnchor={textAnchor || 'end'} fill="#fff">
                {formatApiTimeShortUniversal(d.time)}
            </text>
        </g>
    );
}

export { ChartAxisSecondsSince };
